// extracted by mini-css-extract-plugin
export var header = "_uy-1";
export var maskBottom = "_uy-6";
export var maskMiddle = "_uy-7";
export var maskTop = "_uy-5";
export var root = "_uy-0";
export var scrollDownButton = "_uy-3";
export var scrollDownButtonHidden = "_uy-4";
export var viewport = "_uy-2";